<template>
  <div class="good-pic">
    <div class="big-pic">
      <div
        v-if="video"
        class="videoWrap"
        :style="{display: currentType == 'video' ? 'block' : 'none'}"
      >
        <img
          v-if="!isPlay"
          src="../../assets/images/video-icon.png"
          class="playIcon"
          @click="controlVideo"
        />
        <video
          id="videBig"
          :controls="showControls"
          :src="video"
          :poster="videoPic"
        >当前浏览器不支持该视频播放</video>
      </div>
      <div :style="{display: currentType == 'video' ? 'none' : 'block'}">
        <img
          :src="picList[currentPicIndex] && picList[currentPicIndex].imgPath"
          alt
        />
        <!-- 抢光了 -->
        <!-- <img class="soldOut" :src="require('@assets/images/allGone.png')" alt v-if="bizStock === 0 && picList[currentPicIndex].isMaster" /> -->
        <!-- 爆炸贴图片 -->
        <Sticker
          v-if="picList[currentPicIndex].isMaster"
          :imgList="stickerImgList"
        />
        <span
          v-if="isShowTag"
          class="tag"
        >{{ tagText || "" }}</span>
      </div>
    </div>

    <div class="small-pic clearfix">
      <div
        class="prev fl"
        :class="{ disabled: currentPicIndex <= 0 }"
        @click="getPrevPic"
      >
        <i class="icon iconfont pdp_location vertical-middle pre">&#xe646;</i>
      </div>
      <div class="fl pic-list-box">
        <ul
          ref="picList"
          class="fl pic-list"
          :style="{ left: -left + 'px' }"
        >
          <li
            v-for="(pic, index) in picList"
            :key="index"
            :class="{
              current: index === currentPicIndex}"
            @click="
              chooseCurrent(index, pic.type)
            "
          >
            <div
              v-if="pic.type == 'video'"
              class="videoWrap"
            >
              <img
                src="../../assets/images/video-icon.png"
                class="playIcon"
              />
              <img
                v-if="videoPic"
                :src="videoPic"
                class="videoPic"
              />
              <video
                v-else
                id="vide"
                :controls="false"
                :src="pic.path"
              ></video>
            </div>
            <img
              v-else
              :src="pic.imgPath"
              alt
            />
          </li>
        </ul>
      </div>
      <div
        class="next fr"
        :class="{ disabled: picList.length - this.currentPicIndex <= 1 }"
        @click="getNextPic"
      >
        <i class="icon iconfont pdp_location vertical-middle next">&#xe646;</i>
      </div>
    </div>
  </div>
</template>

<script>
import Sticker from '@components/sticker';

export default {
  components: {
    Sticker,
  },
  props: {
    picList: Array,
    isShowTag: Boolean,
    tagText: String,
    stickerImgList:Array,
    bizStock: {
      type: Number || undefined,
      default: null,
    },
    video: String,
    videoPic: String,
  },
  data() {
    return {
      currentType: this.picList[0].type && this.picList[0].type == 'video' ? 'video' : '',
      currentPicIndex: 0,
      isPlay: false, // 视频播放
      showControls: false,
    };
  },
  computed: {
    /**
     * 获取图片列表移动距离
     * @return { Number } 列表移动距离
     */
    left: function() {
      if (this.picList.length <= 5) {
        return 0;
      } else if (this.picList.length - this.currentPicIndex <= 5) {
        return (this.picList.length - 5) * 70;
      }
      return this.currentPicIndex * 70;
    },
  },
  methods: {
    pauseVideo() {
      if (this.currentType == 'video') {
        var vide = document.getElementById('videBig');
        vide && vide.pause();
        this.isPlay = false;
        this.showControls = false;
      }
    },
    chooseCurrent(index, type) {
      if (index != 0) {
        this.pauseVideo();
      }
      this.currentPicIndex = index;
      this.currentType = type;
    },
    // 点击上一张按钮
    getPrevPic() {
      if (this.currentPicIndex <= 0) {
        return;
      }
      this.pauseVideo();
      this.currentType = this.picList[this.currentPicIndex-1].type;
      this.currentPicIndex--;
    },
    // 点击下一张按钮
    getNextPic() {
      if (this.currentPicIndex + 1 < this.picList.length) {
        this.pauseVideo();
        this.currentType = this.picList[this.currentPicIndex+1].type;
        this.currentPicIndex++;
        return;
      }
    },
    // 控制video播放
    controlVideo(e) {
      e.stopPropagation();
      e.preventDefault();
      var vide = document.getElementById('videBig');
      if (this.isPlay) {
        // 正在播放，则暂停
        vide.pause();
        this.isPlay = false;
      } else {
        // 未播放，开启播放
        if (vide.paused) {
          vide.play();
          this.isPlay = true;
          this.showControls = true;
          const _this = this;
          vide.addEventListener('ended', function() { //结束
            // console.log("播放结束");
            vide.src = _this.video;
            _this.pauseVideo();
          }, false);
          vide.addEventListener('pause', function() { //结束
            // console.log("播放暂停");
            // _this.pauseVideo();
          }, false);
          vide.addEventListener('play', function() { //结束
            // console.log("继续播放");
          }, false);
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
.good-pic {
  width: 422px;
  // margin: 0 auto;
  .small-pic {
    background: #fff;
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
    img {
      vertical-align: baseline;
    }
    .videoWrap {
      width: 100%;
      height: 100%;
      position: relative;
      cursor: pointer;
      .playIcon {
        width: 20px;
        height: 20px;
        position: absolute;
        top: 50%;
        left: 50%;
        margin-top: -10px;
        margin-left: -10px;
      }
      .videoPic {
        display: block;
        width: 100%;
        height: 100%;
      }
      video {
        width: 100%;
        height: 100%;
      }
    }
  }
}
.big-pic {
  border: 1px solid #f0f0f0;
  width: 420px;
  height: 420px;
  position: relative;
  overflow: hidden;
  // background: #ededed;
  img {
    width: 100%;
    height: 100%;
  }
  .videoWrap {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    .playIcon {
      width: 60px;
      height: 60px;
      position: absolute;
      top: 50%;
      left: 50%;
      margin-top: -30px;
      margin-left: -30px;
      cursor: pointer;
      z-index: 1;
    }
    video {
      width: 100%;
      height: 100%;
    }
  }
  .soldOut{
    width: 53%;
    height: 53%;
    position: absolute;
    top: 23.5%;
    left: 23.5%;
    z-index: 10
  }
  .tag {
    position: absolute;
    white-space: nowrap;
    width: 120px;
    text-align: center;
    background: red;
    color: #fff;
    right: -30px;
    top: 20px;
    transform: rotate(45deg);
    line-height: 24px;
  }
}
.prev,
.next {
  width: 35px;
  height: 40px;
  margin-top: 10px;
  i {
    font-size: 38px;
    color: #b2b2b2;
    line-height: 40px;
  }
  &:hover {
    cursor: pointer;
  }
}
.prev {
  // margin-right: 5px;
  transform: rotate(90deg);
  &.disabled {
    i {
      color: #eee;
      // pointer-events: none;
      cursor: not-allowed;
    }
  }
}
.next {
  transform: rotate(-90deg);
  &.disabled {
    i {
      color: #eee;
      // pointer-events: none;
      cursor: not-allowed;
    }
  }
}
.pic-list-box {
  width: 350px;
  height: 62px;
  overflow: hidden;
  position: relative;
}
.pic-list {
  white-space: nowrap;
  position: absolute;
  left: 0;
  transition: all 0.3s;
  li {
    margin: 0 5px;
    width: 60px;
    height: 60px;
    box-sizing: border-box;
    border: 2px solid transparent;
    display: inline-block;
    &.current {
      border: 2px solid #3FA6FF;
      border: 2px solid var(--df-primary-color, #3FA6FF);
    }
  }
  img {
    width: 100%;
    height: 100%;
  }
}
</style>
